import { makeVar, useReactiveVar } from '@apollo/client';

interface UseCanvasLoading extends UseCanvasLoadingOperations {
  isLoading: boolean;
}

interface UseCanvasLoadingOperations {
  setIsLoading(isLoading: boolean): void;
}

const isLoadingVar = makeVar(false);

function setIsLoading(isLoading: boolean): void {
  if (isLoading !== isLoadingVar()) {
    isLoadingVar(isLoading);
  }
}

export default function useCanvasLoading(): UseCanvasLoading {
  const isLoading = useReactiveVar(isLoadingVar);

  return { isLoading, setIsLoading };
}

export function useCanvasLoadingOperations(): UseCanvasLoadingOperations {
  return {
    setIsLoading,
  };
}
